// Language + path helpers
import { SUPPORTED_LANGS } from "@/i18n";

export function isLang(seg) {
  return SUPPORTED_LANGS.includes(seg);
}

// Build a localized path: localizedPath('en', '/services') -> '/en/services'
export function localizedPath(lang, path = "") {
  const clean = path.startsWith("/") ? path : `/${path}`;
  return `/${lang}${clean === "/" ? "" : clean}`;
}

// Swap the language segment of the current pathname
export function swapLang(pathname, toLang) {
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length && isLang(parts[0])) {
    parts[0] = toLang;
  } else {
    parts.unshift(toLang);
  }
  return "/" + parts.join("/");
}

// Pick bilingual value with controlled fallback to EN
export function pick(obj, lang) {
  if (!obj) return "";
  if (typeof obj === "string") return obj;
  return obj[lang] || obj.en || obj.fr || "";
}

export function formatDate(iso, lang) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString(lang === "fr" ? "fr-CA" : "en-CA", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return iso;
  }
}
